import i18n from '@/api/i18n/i18n';

const typeDict = {
  0: i18n.t('pages.typeDict.text'),
  1: i18n.t('pages.typeDict.files'),
  2: i18n.t('pages.typeDict.screenshot'),
  3: i18n.t('pages.typeDict.fileCopy'),
};

export const type = (val) => typeDict[val];

export const TYPE_NUM = {
  TEXT: 0,
  FILES: 1,
  SCREENSHOT: 2,
  COPY_FILE: 3,
};
